import { useEffect, useState } from 'react';
import Loading from '../../components/Loading/Loading';
import Subscribe from '../../components/Subscribe/Subscribe';
import { urlHelper } from '../../utils/urlHelper';

function Redirect() {
  console.log('redirect', window.location);

  const isOnIframe = window.location !== window.parent.location;
  let urlVars = urlHelper.parseQueryString();

  const [mustSubscribe, setMustSubscribe] = useState<boolean>(false);
  const [replaceInstrument, setReplaceInstrument] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!loaded) {
      setLoaded(true);

      console.log(isOnIframe);

      if (isOnIframe) {
        const object = {
          message: urlVars.errorcode || urlVars.errormessage ? 'redirectError' : 'redirectSuccess',
          payload: urlVars.errorcode || urlVars.errormessage ? urlVars.errorcode : urlVars,
        };

        console.log(object);

        window.parent.postMessage(object, `${window.location.origin}/redirect`);
      } else {
        console.log('test');
        urlVars.isReplaceInstrument ? setReplaceInstrument(true) : setMustSubscribe(true);
      }
    }
  }, [urlVars, loaded, setLoaded, isOnIframe, setMustSubscribe]);

  return (
    <div className="redirect">
      <Subscribe
        externalId={urlVars.externalId}
        subscriptionTypeId={urlVars.subscriptionTypeId}
        mustSubscribe={mustSubscribe}
        replaceInstrument={replaceInstrument}
      />
      <Loading />
    </div>
  );
}

export default Redirect;
